import React, { Component } from "react";
import { DatePicker, Form } from 'antd';
import moment from "moment";
export default class DateTimeContainer extends Component {
  disabledDate = current => {
    return current < moment('1900-01-01') || current > moment('2101-01-01');
  };

  render() {
    const {
      data,
      index
    } = this.props;
    const {
      getFieldDecorator
    } = this.props.form;
    const defaultValue = data.value ? moment(data.value, "YYYY-MM-DD HH:mm:ss") : null;
    const conDateTime = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || "";

          if (data.required && val === "") {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: defaultValue
    })(<DatePicker data-inspector-line="29" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\DateTimeContainer\\index.jsx" disabledDate={this.disabledDate} disabled={data.frontUpdateFlag === 1} getCalendarContainer={triggerNode => triggerNode.parentNode} showTime />);
    return <div data-inspector-line="37" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\DateTimeContainer\\index.jsx" className="detail-sel-dateTime detail-sel-wrap">
        <Form.Item data-inspector-line="38" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\DateTimeContainer\\index.jsx">
          {conDateTime}
        </Form.Item>
      </div>;
  }

}